
import { Component, Vue } from "vue-property-decorator";
import { Util, getExcelJSONDataByList, getPageAPIs } from "@/common/util";
import { MerchantNoticeManageAPI } from "@/common/api/userManage/merchantNoticeManage";
import { CommonApi } from "@/common/api/common";
import {DeepLoop} from '@/common/deepLoop/deepLoop';

export const pageApiList = getPageAPIs(MerchantNoticeManageAPI);

import {
  // commonDefaultMerchantNoticeType2Ch,
  shareConfirmOptions,
  // transferUserLevel2ch,
  defaultUserMemberList,
} from "@/common/config";


const defaultForm = {
  shop_name: '', 
  slogan_opt_name: '', // 手机号
}


@Component({
  filters: {
    // showDeviceTypeName(type: number) {
    //   return commonDefaultMerchantNoticeType2Ch[type] || '未知'
    // }
  }
})
export default class MerchantNoticeManage extends Vue {
  private utilInstance: any;
  private merchantNoticeManageApi: any;
  private commonApi: any;

  private deepLoopUtil: any = {};

  // private dialogVisible:boolean  = false
  // private addForm:any = {
  //   name:'',
  //   province_id:'',
  //   city_id:''
  // }
  // private openType:number = 1 // 1增加 2编辑
  // private ballRoomIDList:any = []

  private provinceList: any[] = []
  constructor() {
    super();
    this.deepLoopUtil = new DeepLoop();

    this.merchantNoticeManageApi = new MerchantNoticeManageAPI();
    this.commonApi = new CommonApi();
    this.utilInstance = new Util();

    this.form = {
      ...this.deepLoopUtil.deepCopy(defaultForm)
    }

  }

  // private get userOwnerId() {
  //   const route = this.$route 

  //   const {
  //     query = {}
  //   } = route || {}

  //   const {
  //     userId = ''
  //   } = query

  //   return userId
  // }

  private firstLoading: boolean = true;

  private form: any = {};

  private created() {
    // this.getMerchantNoticeIDList();
    // this.getMerchantNoticeProvinceList();
  }

  // private allowChildDeviceBtn(row: any) {
  //   const allowDeviceTypes: number[] = [1, 2, 3, 4, 7]

  //   return allowDeviceTypes.includes(row.device_type)
  // }

  private activated(): void {
    this.getTable();
  }
  private getTable(): void {
    this.merchantNoticeManageApi.getMerchantNoticeTableList(
      this.getMerchantNoticeTableListParams(),
      (res: any) => {
        console.log(res, "res");
        // this.tableData = res.data;
        const { data } = res;

        const { list, count, page, prepage } = data || {};

        const newTableList = Array.isArray(list)
          ? list.map(this.handleTableData)
          : [];

        this.$set(this.tablePage, "totalCount", count);
        this.$set(this.tablePage, "pageNo", page);
        this.$set(this.tablePage, "pageSize", prepage);

        this.tableData = newTableList;

        this.firstLoading = false;
      },
      () => {
        this.firstLoading = false;
      }
    );
  }

  // private getMerchantNoticeProvinceList() {
  //   this.merchantNoticeManageApi.getProvince({}, (res: any) => {
  //       this.provinceList = res.data.list
  //     },
  //     () => {}
  //   );
  // }

  // private cityList: any[] = []

  // private onRefreshCity() {
  //   const addForm: any = this.addForm

  //   const {
  //     province_id
  //   } = addForm || {}

  //   if (province_id) {
  //     this.merchantNoticeManageApi.getCity({
  //         city_id: province_id
  //       }, (res: any) => {
  //         this.cityList = res.data.list
  //       },
  //       () => {}
  //     );
  //   }
  // }

  private getMerchantNoticeTableListParams(mode = "all") {
    // mode 可选的值 all  noPageOption exportExcel
    const form = this.form;

    const tablePage = this.tablePage;

    const firstLoading = this.firstLoading;

    const {
      // userId, // 用户ID
      // userName, // 用户昵称
      // mobile, // 手机号
      // userLevel, // 会员等级
      // invite_code, // 邀请码
      // time, // 时间选择
      shop_name,
      slogan_opt_name
    } = form || {};

    const { pageNo, pageSize } = tablePage || {};

    const outerParams: any = {
      // user_id: this.userOwnerId
    };

    if (shop_name) {
      outerParams.shop_name = shop_name
    }

    if (slogan_opt_name) {
      outerParams.slogan_opt_name = slogan_opt_name
    }


    if (mode === "all") {
      outerParams.page = pageNo;

      outerParams.limit = pageSize;

      outerParams.__isUnique = !firstLoading;
    }

    console.log(outerParams, "outerParams");

    return outerParams;
  }

  // 后台返回的字段 转化为前端定义的字段
  private handleTableData(data: any): any {
    const {} = data;

    const newData = {
      ...data,
    };

    return newData;
  }

  // private addEditForm(type:number=1,row:any={}){
  //   this.addForm = new Util().clearObject(this.addForm);
  //   this.openType = type
  //   if(this.openType===2){
  //     this.addForm = {...row}
  //   }
  //   this.dialogVisible = true
  // }

  // private handleComfirm() {
  //   // this.addForm.user_id = this.userOwnerId
  //   if(this.openType===1){
  //     this.merchantNoticeManageApi.addMerchantNotice(this.addForm,
  //         () => {
  //           this.$message.success('新增成功');
  //           this.dialogVisible = false;
  //           this.getTable();
  //         },
  //         () => {
  //         }
  //     );
  //   }else{
  //     this.merchantNoticeManageApi.editMerchantNotice(this.addForm,
  //         () => {
  //           this.$message.success('编辑成功');
  //           this.dialogVisible = false;
  //           this.getTable();
  //         },
  //         () => {
  //         }
  //     );
  //   }

  // }

  // private onGoDeviceChildList(merchantNoticeItem: any) {
  //   const {
  //     id
  //   } = merchantNoticeItem || {}

  //   if (id) {
  //     this.$router.push({
  //       path: "/deviceList",
  //       query: {
  //         shop_id: id,
  //       },
  //     });
  //   }
  // }

  private deleteMerchantNotice(merchantNoticeItem: any) {
    const set = Util.setListProp
    this.$confirm(`确定删除该公告吗?`, "", {
      ...shareConfirmOptions,
    }).then(() => {
      set(
        this,
        this.tableData,
        merchantNoticeItem,
        "__deleteNoticeLoading",
        true
      );

      this.merchantNoticeManageApi.delete({
          id: merchantNoticeItem.id
      },() => {
          set(
            this,
            this.tableData,
            merchantNoticeItem,
            "__deleteNoticeLoading",
            false
          );
          this.getTable();
        },
        () => {
          set(
            this,
            this.tableData,
            merchantNoticeItem,
            "__deleteNoticeLoading",
            false
          );
        })

    })
  }



  private restForm(): void {
    this.form = {
      ...this.deepLoopUtil.deepCopy(defaultForm)
    }

    this.getTable();
  }

  private search(): void {
    this.tablePage.pageNo = 1;
    this.tableData = [];
    this.tablePage.totalCount = 0;

    this.getTable();
  }

  private tableData: any[] = [];

  private tablePage: any = {
    totalCount: 0,
    pageNo: 1,
    pageSize: 10,
    pageSizes: [10, 20, 50, 100, 200, 500],
  };

  private handlePageChange(val: any) {
    this.tablePage.pageNo = val.currentPage;
    this.tablePage.pageSize = val.pageSize;

    this.getTable();
  }

  private exportTable() {
    // new HealthWarning().exportTable(this.form);
  }
}
